<div class="flex flex-col h-full">
  <mat-dialog-content class="relative p-0">

    <mat-sidenav-container class="h-full w-full">
      <!-- Barra superior con botones -->
      <div class="absolute top-[10%] right-2 z-50 flex items-center justify-between p-1 bg-white border-b border-gray-200 shadow-sm">
        @if (typeSimple === mapModalTypeEnum.VISIT_ROUTE) {
          <mat-button-toggle-group multiple [ngModelOptions]="{ standalone: true }" [ngModel]="[]"
            (ngModelChange)="onToggleChange($event)">
            <mat-button-toggle value="location-ave" matTooltip="Ubicación AVE">
              <span class="text-xs font-medium state-label uppercase">Ub. AVE</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        }
        @if(isModal){
        <button mat-icon-button (click)="openInNewWindow()" matTooltip="Abrir en nueva ventana">
          <mat-icon svgIcon="heroicons_outline:window"></mat-icon>
        </button>
        }
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        @if(typeSimple === mapModalTypeEnum.GROUPED_WITH_FILTER || typeSimple === mapModalTypeEnum.FRECUENCY_ROUTE
        || typeSimple === mapModalTypeEnum.FRECUENCY_DATE_ROUTE || typeSimple == mapModalTypeEnum.VISIT_ROUTE_GLOBAL_FILTER){
        <button mat-icon-button (click)="sidenav.toggle()" matTooltip="Mostrar filtro">
          <mat-icon svgIcon="heroicons_outline:funnel"></mat-icon>
        </button>
        }
      </div>

      <!-- Mapa -->
      <div [ngClass]="isModal ? 'flex flex-col h-full' : 'h-screen w-screen flex flex-col'">
        <ng-container *ngIf="isDataLoaded; else loading">
          <app-geo-manager class="w-full h-full block" *ngIf="isDataLoaded" [zoom]="data.map.zoom ?? 13"
            [center]="data.map.center ?? [51.505, -0.09]" [markerGroups]="filteredMarkerGroups"
            [displayMode]="data.map.displayMode ?? 'tooltip'"
            [enableSelectionMode]="data.map.enableSelectionMode ?? false"
            [selectionActions]="data.map.selectionActions ?? []"
            [autoSelectFirstMarker]="data.map.autoSelectFirstMarker ?? false"
            [preventDismissDetails]="data.map.preventDismissDetails ?? false"
            [disableMarkerDetails]="data.map.disableMarkerDetails ?? false" [captions]="data.map.captions ?? {}">
          </app-geo-manager>
        </ng-container>
        <ng-template #loading>
          <div class="flex items-center justify-center h-[300px]">
            <div class="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-950"></div>
          </div>
        </ng-template>
      </div>
    </mat-sidenav-container>
  </mat-dialog-content>

  <!-- Botón de cierre -->
  @if(isModal){
  <mat-dialog-actions class="flex justify-end p-2">
    <button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
  </mat-dialog-actions>
  }
</div>

<!-- Panel lateral de filtros -->
<mat-sidenav #sidenav mode="side" position="end" class="mat-sidenav-content p-0 bg-white" closed>
  <div class="flex flex-col h-full">
    <div class="flex h-[64px] items-center border-b justify-between bg-white text-gray-500 py-4 px-2">
      <div class="flex gap-3">
        <button (click)="sidenav.close()">
          <mat-icon svgIcon="heroicons_outline:funnel" class="mr-2 w-4 h-4"></mat-icon>
        </button>
        <h2 class="text-current text-lg font-bold">Filtrar</h2>
      </div>
      <button mat-icon-button class="h-full" (click)="sidenav.close()" matTooltip="Cerrar">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto flex flex-col gap-1 pt-4 px-3 bg-gray-50">
      @if(typeSimple == mapModalTypeEnum.VISIT_ROUTE_GLOBAL_FILTER){
      <app-routes-filters [form]="form" [type]="true" [route]="true" 
      [reasonVisit]="true" [flagReasonVisitName]="true" [reasonVisits]="reasonVisits"
      [statusTrip]="true"></app-routes-filters>
      }
      @else{
      <app-routes-filters [form]="form" [reasonVisit]="data.document === monitorDocumentTypeEnum.VISIT"
        [frecuencyDay]="useFrecuency && typeSimple === mapModalTypeEnum.FRECUENCY_DATE_ROUTE" 
        [frecuency]="useFrecuency && typeSimple !== mapModalTypeEnum.FRECUENCY_DATE_ROUTE" 
        [routeId]="useFrecuency && typeSimple ? this.data.element?._id : null"></app-routes-filters>

      <!-- Filtro de Grupo -->
      <app-business-partners-filters [form]="form" [businessGroupList]="typeSimple === mapModalTypeEnum.FRECUENCY_DATE_ROUTE ? [] : groupList" [businessGroupWithMongoId]="true" 
        [businessPartnerFilter]="true" [businessPartnerFilterList]="clientList" 
        (groupChanged)="updateClientList()"></app-business-partners-filters>
      }

      @if(this.data.document === monitorDocumentTypeEnum.PROGRESS){
      <app-documents-filters [form]="form" [documentTypeFilter]="true"
        [documentTypeListFilter]="this.data.groupDocuments"></app-documents-filters>
      }
    </div>

    <div class="flex h-[60px] justify-between mt-4 px-4">
      <button mat-button  (click)="clearFilters()">
        Limpiar
      </button>
      <button mat-flat-button color="primary"  (click)="applyFilters()">
        Aplicar
      </button>
    </div>
  </div>
</mat-sidenav>